import { LinkedinTypes } from 'enums';

export enum SearchTypes {
  WEBSITE = 'website_visitors',
  CONTACTS = 'contacts',
}

export enum SuspensionReasons {
  COOKIES_INVALID = 'cookies are invalid',
}

export interface LinkedinSearchProject {
  id: string;
  name: string;
  searchKeywords: { keyword: string; isFinished: boolean; results: string[] }[];
  analysisStarted: boolean;
  analysisFinished?: boolean;
  expiresOn: string;
  status: boolean; // is the project usable - license not expired + quota available
  isSuspended: boolean;
  suspensionReason?: SuspensionReasons;
  sessionCookie?: string;
  liAtCookie?: string;
  product?: LinkedinTypes;
  searchType: SearchTypes;
}

export enum FileColumnVariants {
  MANUAL_CAMPAIGN_CONTACT_UPLOAD = 'manualCampaignContactUpload',
  LINKEDIN_PROFILE_FINDER_CONTACTS_UPLOAD = 'linkedinProfileFinderContactsUpload',
  LINKEDIN_PROFILE_FINDER_WEBSITE_VISITORS_UPLOAD = 'linkedinProfileFinderWebsiteVisitorsUpload',
  BLACKLISTED_COMPANIES = 'blacklistedCompanies',
}
